import React, { useReducer } from 'react'
import Header from '../Layout/Header'
import Footer from '../Layout/Footer'
import './Page-style/contactUs.scss'
import Button from '../UI/UIComponent/Button'
import Input from '../UI/UIComponent/Input'
import { submitPatientQuery } from '../api/services/global-service'
import locationImage from '../assets/Images/Global/locationImage.jpg'
import phoneImage from '../assets/Images/Global/phoneImage.png'
import emailImage from '../assets/Images/Global/emailImage.png'
import calendarImage from '../assets/Images/Global/calendarImage.png'
import Faq from '../UI/Global-Component/Faq'

const FullNameReducer = (state, action) => {
  if (action.type === 'user_Name') {
    return { value: action.value, isFullNameValid: action.value.length > 3 }
  }
}

const EmailReducer = (state, action) => {
  if (action.type === 'user_email') {
    return { value: action.value, isEmailValid: action.value.includes('@') }
  }
}
const messageReducer = (state, action) => {
  if (action.type === 'user_message') {
    return { value: action.value, isMessageValid: action.value.length > 3 }
  }
}

const ContactUs = () => {
  const [setFullName, DispatcherNameEvent] = useReducer(FullNameReducer, {
    value: '',
    isFullNameValid: null,
  })
  const [setEmail, DispatcherEmailEvent] = useReducer(EmailReducer, {
    value: '',
    isEmailValid: null,
  })
  const [setMessage, DispatcherMessageEvent] = useReducer(messageReducer, {
    value: '',
    isMessageValid: null,
  })
  const onNameChange = (e) => {
    DispatcherNameEvent({
      value: e.target.value,
      type: 'user_Name',
    })
  }
  const onEmailChange = (e) => {
    DispatcherEmailEvent({
      value: e.target.value,
      type: 'user_email',
    })
  }
  const onMessageEnter = (e) => {
    DispatcherMessageEvent({
      value: e.target.value,
      type: 'user_message',
    })
  }

  const { isFullNameValid: Namevalid } = setFullName
  const { isEmailValid: EmailValid } = setEmail
  const { isMessageValid: MessageValid } = setMessage

  const handleFormSubmit = async () => {
    const payload = {
      patient_name: setFullName.value,
      patient_email: setEmail.value,
      query_type: setMessage.value,
      queryRaisedOn: new Date(),
    }

    if (Namevalid && EmailValid && MessageValid) {
      const responseData = await submitPatientQuery(payload)
      console.log(responseData)
    }
  }

  return (
    <>
      <Header pageId={'5'}></Header>
      <section>
        <div className="contact-us">
          {/* Contact Information */}
          <h2 className="contact-us__heading">Contact Us</h2>
          <div className="contact-us__top-container">
            <div className="my-6 text-center">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3685.6162452089825!2d88.38370627507604!3d22.51857697953025!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a027776d1ba3bfb%3A0x2b4bd67d472186f0!2sRever%20Health%20Solution!5e0!3m2!1sen!2sin!4v1756294351389!5m2!1sen!2sin"
                width="100%"
                height="450"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <div className="contact-grid grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
              <div>
                <div>
                  <img src={locationImage} className="icon" alt=""></img>
                </div>
                <div>
                  <h3 className="font-bold">Our Address</h3>
                  <p>Kolkata, West Bengal 700042</p>
                </div>
              </div>
              <div>
                <div>
                  <img src={phoneImage} className="icon" alt=""></img>
                </div>
                <div>
                  <h3 className="font-bold">Phone Number</h3>
                  <p>89808 76407</p>
                </div>
              </div>
              <div>
                <div>
                  <img src={emailImage} className="icon" alt=""></img>
                </div>
                <div>
                  <h3 className="font-bold">E-mail Address</h3>
                  <p>info@reverhealthsolution.com</p>
                </div>
              </div>
              <div>
                <div>
                  <img src={calendarImage} className="icon" alt=""></img>
                </div>
                <div>
                  <h3 className="font-bold">Working Days/Hours</h3>
                  <p>Monday-Saturday: 10:00 AM - 9:00 PM</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="contact-us__form-container my-12 bg-white shadow-lg rounded-lg max-w-4xl mx-auto">
            <div className="form-section p-8 bg-gray-100">
              <h2 className="text-3xl font-bold text-center">
                Send Us a Message
              </h2>

              <Input
                className="block w-full p-2 border mb-4"
                inputPlaceholder="Enter Your Full Name"
                inputType="text"
                required
                handleonChange={onNameChange}
                isInputValid={Namevalid}
              ></Input>
              <Input
                className="block w-full p-2 border mb-4"
                inputPlaceholder="Enter Your Email"
                inputType="email"
                required
                handleonChange={onEmailChange}
                isInputValid={EmailValid}
              ></Input>
              <textarea
                className={`message-field ${
                  MessageValid === false ? 'input-error' : ''
                }`}
                placeholder="Your Message *"
                required
                onChange={onMessageEnter}
              ></textarea>
              <Button
                primaryButton={true}
                buttonClickHandler={handleFormSubmit}
                className="text-align-center mt-4"
              >
                Send Message
              </Button>
            </div>
            <div className="faq-container">
              <Faq></Faq>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </section>
    </>
  )
}

export default ContactUs
